import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './read_blog.css'

export default function ReadBlog() {
  const location = useLocation();
  const navigate = useNavigate();
  const blog = location.state?.blog;

  if (!blog) {
    return (
      <div className="container mt-4">
        <p>Blog data not available.</p>
        <button className="btn btn-primary" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="container mt-4 blog-container">
      <h1 className="mb-3">{blog.title}</h1>
      <p className="text-muted">
        By {blog.authorType.toLowerCase()} |{" "}
        {new Date(blog.createdAt).toLocaleDateString()}
      </p>

      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      ></div>

      {blog.imageUrls && blog.imageUrls.length > 1 && (
        <div className="additional-images mt-4">
          {blog.imageUrls.slice(1).map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${blog.title}-${index}`}
              className="img-fluid me-2 mb-2"
              style={{ maxWidth: "200px" }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
